(function () {
  'use strict';

  var ctx = document.getElementById('sp-rv26-ctx');
  var pid = ctx && ctx.getAttribute('data-pid');
  if (!pid) return;

  var BASE = /^(localhost|127\.0\.0\.1)$/.test(location.hostname) ? 'http://localhost:8686' : 'https://simplepaper.app';
  var items = null;
  var asked = false;
  var MAX_W = 1600;
  if (window.__spQA == null) window.__spQA = (function () { var q = /[?&]sp_qa=([01])(?:&|$)/.exec(location.search), s = false; try { if (q) localStorage.setItem('sp_qa', q[1]); s = localStorage.getItem('sp_qa') === '1'; } catch (e) {} var r = window.Shopify && window.Shopify.theme && window.Shopify.theme.role; return s || /^(localhost|127\.0\.0\.1)$/.test(location.hostname) || /SimplePaperQA/.test(navigator.userAgent) || (!!r && r !== 'main'); })();
  var consent = null;
  var waiting = [];
  function allowed() {
    try { var api = window.Shopify && window.Shopify.customerPrivacy; if (!api || typeof api.analyticsProcessingAllowed !== 'function') return null; return !!api.analyticsProcessingAllowed(); } catch (e) { return null; }
  }
  function settle() {
    var a = allowed(); if (a === null) return;
    consent = a;
    var w = waiting; waiting = [];
    if (a) w.forEach(function (f) { f(); });
  }
  settle();
  document.addEventListener('visitorConsentCollected', settle);
  setTimeout(settle, 1200);
  setTimeout(function () { if (consent === null) { consent = false; waiting = []; } }, 8000);
  function gated(f) {
    if (window.__spQA) return false;
    if (consent === true) { f(); return true; }
    if (consent === null && waiting.length < 200) waiting.push(f);
    return false;
  }
  function track(name, props) {
    if (window.__spQA) { console.debug('[sp-review-thumbs] qa visit, not sent', name, props); return; }
    gated(function () {
      try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, props); } catch (e) {}
      try { if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, props); } catch (e) {}
      try { if (typeof window.gtag === 'function') window.gtag('event', name, props); } catch (e) {}
    });
  }
  var queue = [];
  function count(photo, crop, type, extra) {
    if (window.__spQA) { console.debug('[sp-review-thumbs] qa visit, not counted', type, photo, crop, extra || ''); return; }
    gated(function () {
      var e = { photo: photo, crop_id: crop, type: type };
      if (extra) for (var k in extra) e[k] = extra[k];
      queue.push(e);
      if (queue.length >= 60) flush();
    });
  }
  function flush() {
    if (!queue.length) return;
    var batch = queue.splice(0, 60);
    try {
      fetch(BASE + '/api/review-thumb-events', { method: 'POST', credentials: 'omit', keepalive: true, headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product_id: String(pid), events: batch }) }).catch(function () {});
    } catch (e) {}
    if (queue.length) flush();
  }
  setInterval(flush, 5000);
  addEventListener('pagehide', flush);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
  var seenThumb = {};
  var seenStrip = typeof WeakSet === 'function' ? new WeakSet() : null;
  var watch = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (en) {
      if (!en.isIntersecting) return;
      var b = en.target; watch.unobserve(b);
      var k = b.getAttribute('data-sp-rt-photo') + ':' + b.getAttribute('data-sp-rt');
      if (!seenThumb[k]) { seenThumb[k] = 1; count(b.getAttribute('data-sp-rt-photo'), b.getAttribute('data-sp-rt'), 'view'); }
      var strip = b.closest('.sp-kr-strip');
      if (strip && seenStrip && !seenStrip.has(strip)) {
        seenStrip.add(strip);
        track('sp_review_thumbs_view', { product_id: String(pid), thumbs: strip.querySelectorAll('.sp-kr-thumb[data-sp-rt]').length });
      }
    });
  }, { threshold: 0.5 }) : null;

  function photoId(src) {
    var m = String(src || '').match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i);
    return m ? m[0].toLowerCase() : null;
  }

  function fetchOnce() {
    if (asked) return;
    asked = true;
    fetch(BASE + '/api/review-thumbs?product=' + encodeURIComponent(pid), { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.items) return;
        items = d.items;
        document.querySelectorAll('.sp-kr-thumb').forEach(function (b) { apply(b, b.querySelector('img')); });
        if (typeof tiles === 'function') tiles();
      })
      .catch(function () {  });
  }

  function weight(c) { return c.w > 0 ? c.w : (c.state === 'best' ? 3 : 1); }
  function inPool(c) { return c.w > 0 || (c.w == null && (c.state === 'best' || c.state === 'good')); }

  function pick(id, pool) {
    var key = 'sp-rt:' + id, kept = null;
    try { kept = sessionStorage.getItem(key); } catch (e) {}
    for (var i = 0; i < pool.length; i++) if (pool[i].id === kept) return pool[i];
    var total = 0;
    pool.forEach(function (c) { total += weight(c); });
    var r = Math.random() * total, c = pool[pool.length - 1];
    for (var j = 0; j < pool.length; j++) { r -= weight(pool[j]); if (r < 0) { c = pool[j]; break; } }
    try { sessionStorage.setItem(key, c.id); } catch (e) {}
    return c;
  }
  function sharper(src, zoom, rot, box) {
    if (!/\/plain\//.test(src)) return src;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = Math.min(MAX_W, Math.ceil(box * dpr * zoom / 40) * 40);
    if (rot % 180) w = Math.min(MAX_W, Math.ceil(w * 1.4 / 40) * 40);
    return src.replace(/\/width:\d+\//, '/width:' + w + '/');
  }
  function place(img, c, rot) {
    var Wu = 100 / c.sx, Hu = 100 / c.sy;
    var cx = -c.x * Wu + Wu / 2, cy = -c.y * Hu + Hu / 2;
    var q = rot % 180 !== 0;
    var w = q ? Hu : Wu, h = q ? Wu : Hu;
    var s = img.style;
    s.position = 'absolute';
    s.setProperty('max-width', 'none', 'important');
    s.setProperty('object-fit', 'fill', 'important');
    s.setProperty('width', w.toFixed(3) + '%', 'important');
    s.setProperty('height', h.toFixed(3) + '%', 'important');
    s.left = (cx - w / 2).toFixed(3) + '%';
    s.top = (cy - h / 2).toFixed(3) + '%';
    s.rotate = rot ? rot + 'deg' : '';
  }

  function apply(btn, img) {
    if (!btn || !img) return;
    if (!items) { fetchOnce(); return; }
    if (btn.hasAttribute('data-sp-rt')) return;
    var attr = img.hasAttribute('data-src') ? 'data-src' : 'src';
    var id = photoId(img.getAttribute(attr));
    var it = id && items[id];
    if (!it || !it.crops) return;
    var pool = it.crops.filter(inPool);
    if (!pool.length) return;
    var c = pick(id, pool);
    var rot = parseFloat(img.style.rotate) || 0;
    btn.style.overflow = 'hidden';
    place(img, c, ((rot % 360) + 360) % 360);
    var where = btn.getAttribute('data-sp-kr-where');
    if (c.zoom > 1) img.setAttribute(attr, sharper(img.getAttribute(attr), c.zoom, rot, where === 'strip' ? 64 : where === 'row' ? 160 : 130));
    btn.setAttribute('data-sp-rt', c.id);
    btn.setAttribute('data-sp-rt-photo', id);
    if (watch) watch.observe(btn);
    btn.addEventListener('click', function () {
      count(id, c.id, 'click');
      track('sp_review_thumb_click', { product_id: String(pid), photo: id, crop_id: c.id });
    });
  }

  window.spThumbCrop = apply;
  var TILES_TO_STUDIO = true;
  var ARM = (function () {
    var q = /[?&]sp_tile=(crop|plain)(?:&|$)/.exec(location.search), a = null;
    try { a = q ? q[1] : localStorage.getItem('sp-rt-tile'); if (a !== 'crop' && a !== 'plain') a = Math.random() < 0.5 ? 'crop' : 'plain'; localStorage.setItem('sp-rt-tile', a); } catch (e) { a = q ? q[1] : 'plain'; }
    return a;
  })();

  function tileSrc(src, zoom, rot, box) {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = Math.min(MAX_W, Math.ceil(box * dpr * zoom * (rot % 180 ? 1.4 : 1) / 40) * 40);
    return src.replace(/\/(?:width|height|resizing_type):[^/]+/g, '').replace(/\/plain\//, '/width:' + w + '/plain/');
  }

  var tileSeen = false, tileWatch = null;
  function tileCrop(t) {
    var img = t.querySelector('img');
    if (!img || img.__spRtTile || t.querySelector('.kl_reviews__video_overlay, video')) return;
    img.__spRtTile = true;
    var id = photoId(img.getAttribute('src'));
    if (!id) return;
    t.setAttribute('data-sp-rt-arm', ARM);
    t.setAttribute('data-sp-rt-photo', id);
    var c = null;
    if (ARM === 'crop' && items && items[id] && items[id].crops) {
      var pool = items[id].crops.filter(inPool);
      if (pool.length) c = pick(id, pool);
    }
    if (c) {
      var rot = parseFloat(img.style.rotate) || (typeof window.spKrRotationFor === 'function' ? window.spKrRotationFor(img) || 0 : 0);
      rot = ((rot % 360) + 360) % 360;
      if (/\/plain\//.test(img.getAttribute('src'))) img.setAttribute('src', tileSrc(img.getAttribute('src'), c.zoom || 1, rot, t.offsetWidth || 185));
      place(img, c, rot);
      t.setAttribute('data-sp-rt', c.id);
    } else t.removeAttribute('data-sp-rt');
    if (t.__spRtClick) return;
    t.__spRtClick = true;
    t.addEventListener('click', function () {
      var ph = t.getAttribute('data-sp-rt-photo'), cid = t.getAttribute('data-sp-rt') || 'whole';
      if (!ph) return;
      var all = Array.prototype.slice.call(document.querySelectorAll('.kl_reviews__summary_image'));
      track('sp_review_tile_click', { product_id: String(pid), arm: ARM, photo: ph, crop_id: cid, position: all.indexOf(t) + 1 });
      if (TILES_TO_STUDIO) count(ph, cid, 'click', { surface: 'tile', arm: ARM, pos: all.indexOf(t) + 1 });
    });
    if (tileWatch && !tileSeen) tileWatch.observe(t);
    if (tileView && !t.__spRtViewed) tileView.observe(t);
  }

  function tiles() {
    var ts = document.querySelectorAll('.kl_reviews__summary_image');
    if (!ts.length) return;
    if (ARM === 'crop' && !items) { fetchOnce(); return; }
    for (var i = 0; i < ts.length; i++) tileCrop(ts[i]);
  }

  if ('IntersectionObserver' in window) tileWatch = new IntersectionObserver(function (es) {
    for (var i = 0; i < es.length; i++) {
      if (!es[i].isIntersecting || tileSeen) continue;
      tileSeen = true;
      tileWatch.disconnect();
      track('sp_review_tiles_view', { product_id: String(pid), arm: ARM, tiles: document.querySelectorAll('.kl_reviews__summary_image').length });
    }
  }, { threshold: 0.5 });
  var tileView = TILES_TO_STUDIO && 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    for (var i = 0; i < es.length; i++) {
      var t = es[i].target;
      if (!es[i].isIntersecting || t.__spRtViewed) continue;
      t.__spRtViewed = true;
      tileView.unobserve(t);
      var ph = t.getAttribute('data-sp-rt-photo');
      var pos = Array.prototype.indexOf.call(document.querySelectorAll('.kl_reviews__summary_image'), t) + 1;
      if (ph && pos >= 1 && pos <= 6) count(ph, t.getAttribute('data-sp-rt') || 'whole', 'view', { surface: 'tile', arm: ARM, pos: pos });
    }
  }, { threshold: 0.5 }) : null;
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; tiles(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  tiles();
  fetchOnce();
})();
